import posed from 'react-pose';

const Animate = posed.div({
  open: {
    delayChildren: 250,
    staggerChildren: 50,
  },
  closed: { delay: 250 },
});

export default Animate;



// WEBPACK FOOTER //
// ./src/components/Animate/index.js